import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { App } from "../App";
import { LPXConfig, LPXReserves, LPXShare } from "../contracts/LPXContract";
import { ERC20Contract } from "../contracts/ERC20Contract";
import { BiMath } from "../libs/BiMath";
import { LPXInfo } from "../api/classes/models";

export class CmpWidgetLPXControl extends com.CmpWidgetLPXControlBase {

    private _lpxInf:LPXInfrastructure;
    private _config:LPXConfig;
    private _poolReserve:LPXReserves;
    private _share:LPXShare;
    private _pool:LPXInfo;
    private _fundDecimal:bigint = BiMath.Decimal;
    private _anchorDecimal:bigint = BiMath.Decimal;

    constructor() {
        super();
        this.hide();
        const ctrl = this.ctrls;
        ctrl.btnStartLPX.onclick=async ()=>{
            await App.gui.awaitInLockUIAsync(this._tryStartLPXAsync());
        }
    }


    private _fundAdr="";
    private _acnhorAdr="";
    public async refreshAsync(pool:LPXInfo)
    {
        this._pool = pool;
        this._fundDecimal = BiMath.Pow10(pool.fundToken.decimals);
        this._anchorDecimal = BiMath.Pow10(pool.anchorToken.decimals);
        return;
        const ctrl = this.ctrls;
        this._pool = pool;
        ctrl.tglStartLPX.active();

        const account = App.chain.account;   
        const lpxInf=App.Inst.getInst(LPXInfrastructure);
        this._lpxInf=lpxInf;
      
        const fundAdr = this._lpxInf.pAdrToAdr(this._config.fundToken);
        const anchorAdr = this._lpxInf.pAdrToAdr(this._config.anchorToken);
        this._fundAdr = fundAdr;
        this._acnhorAdr = anchorAdr;

        const fundSymbol = await this._lpxInf.getSymbolAsync(fundAdr);
        const anchorSymbol = await this._lpxInf.getSymbolAsync(this._lpxInf.pAdrToAdr(this._config.anchorToken));

        ctrl.cmpStartMaxPrice.setToken(anchorSymbol, anchorAdr);
        ctrl.cmpStartPrice.setToken(anchorSymbol, anchorAdr);
        ctrl.cmpStartTokens.ctrls.cmpInputTokenAmount0.setToken(fundSymbol, fundAdr);
        ctrl.cmpStartTokens.ctrls.cmpInputTokenAmount1.setToken(anchorSymbol, anchorAdr);

        ctrl.cmpStartMaxPrice.ctrls.iValue.value=
        ctrl.cmpStartPrice.ctrls.iValue.value=
        ctrl.cmpStartTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value=
        ctrl.cmpStartTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value="";
    }



    private async _tryStartLPXAsync()
    {
        const fundAdr = this._lpxInf.pAdrToAdr(this._config.fundToken);
        const anchorAdr = this._lpxInf.pAdrToAdr(this._config.anchorToken);
        const pack = this._lpxInf.unpackConfigPack(this._config.pack);

        const erc20Fund = new ERC20Contract(fundAdr, App.chain.provider);
        const erc20Anchor = new ERC20Contract(anchorAdr, App.chain.provider);

        const valueFund = this.ctrls.cmpStartTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value;
        const valueAnchor = this.ctrls.cmpStartTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value;
        
        let valueFundBi = BiMath.ToBI(valueFund)*this._fundDecimal/BiMath.Decimal;
        let valueAnchorBi = BiMath.ToBI(valueAnchor)*this._anchorDecimal/BiMath.Decimal;

        const maxPrice = this.ctrls.cmpStartMaxPrice.ctrls.iValue.value;
        const price = this.ctrls.cmpStartPrice.ctrls.iValue.value;

        let maxPriceBi = BiMath.ToBI(maxPrice)*this._anchorDecimal/this._fundDecimal;
        let priceBi = BiMath.ToBI(price)*this._anchorDecimal/this._fundDecimal;

        const checkResult = this._lpxInf.check(valueFundBi, valueAnchorBi, priceBi, maxPriceBi, pack.feeIndex);
        if (checkResult.error)
        {
            this.ctrls.cmpStartMaxPrice.ctrls.iValue.value = BiMath.ToEth(checkResult.endPrice*this._fundDecimal/this._anchorDecimal);
            App.gui.dialogOkShowAsync("Can't start LPX with these parameters. Need to change one or more of the input parameters: Max Price, Sell Price or Start Amount.\n\n"+checkResult.error);
            return;
        }

        const balanceEth = await App.chain.getBalanceEth();
        if (balanceEth === undefined)
        {
            App.gui.dialogOkShowAsync("Unable to read wallet balance. Please reconnect wallet and try again.");
            return;
        }
        let valuePayBi=BiMath.Zero;

        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceFund = await erc20Fund.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceFund)<valueFundBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueFundBi)
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
            valuePayBi = valueFundBi;
        }

        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceAnchor = await erc20Anchor.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceAnchor)<valueAnchorBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueAnchorBi)
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
            valuePayBi = valueAnchorBi;
        }

        const stepTx0 = App.gui.getTxLockText();
        const stepTx1 = 
        "Step 1 of 3\n"+
        "Fund token approval is pending.\n"+
        "Please wait - this may take a few minutes.\n"+
        "Two more transactions will start automatically.\n"
        const stepTx2 = 
        "Step 2 of 3\n"+
        "Anchor token approval is pending.\n"+
        "Please wait - this may take a few minutes.\n"+
        "One more transaction will start automatically.\n"
        const stepTx3 = 
        "Step 3 of 3\n"+
        "LPX is starting.\n"+
        "Please wait - this may take a few minutes.\n"

        
        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            App.gui.setTxLockText(stepTx1);
            const approved = await erc20Fund.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueFundBi)
            {
                const approveResult = await erc20Fund.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueFundBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
            }
        } 
        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            App.gui.setTxLockText(stepTx2);
            const approved = await erc20Anchor.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueAnchorBi)
            {
                const approveResult = await erc20Anchor.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueAnchorBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
            }
        }
        App.gui.setTxLockText(stepTx3);
        const result = await this._lpxInf.lpxCtrlPools.poolStart(BiMath.ToEth(valuePayBi), this._pool.poolId, checkResult.reserves);
        if (result) this._informTxSuccessful();
        App.gui.setTxLockText(stepTx0);
        this._lpxInf.refreshAsync();
    }

    private _informTxSuccessful() { App.gui.dialogOkShowAsync("✅Transaction successful!","") }
}
